import { Outlet } from 'react-router-dom';
import AppLayout from '@/components/Layouts/AppLayout';

export function ContabilidadLayout() {
  return (
    <AppLayout prevButtonVisible={false}>
      <Outlet />
    </AppLayout>
  );
}
